import React, { useEffect, useState } from 'react';
import styled from 'styled-components';


//===IMPORT STYLES====
import {
Wrapper,
DashIcons, 
Left, 
Center, 
Right,
LastDashIconContainer, 
DashIconContainer,
Link, 
LeftCaption, 
DashLogo, 
CenterCaption,
NotificationStatus  
} from './dashboardBarStyle'



//===IMPORT COMPONENT====
import image from '../../icons/dashboardBarIcons/BlueLogo.png'
import WalletIcon from '../../icons/dashboardBarIcons/Wallet';
import Account from '../../icons/dashboardBarIcons/Account';
import Rentals from '../../icons/dashboardBarIcons/Rentals';
import Message from '../../icons/dashboardBarIcons/Message';
import { useTranslation } from 'react-i18next';
import NotificationIcon from '../../icons/dashboardBarIcons/NotificationIcon';


export const Dash = styled.div`
  display: flex;
  width: 100%;
  position: sticky;
  top:0;
  right:0;
  background-color: black;
  z-index:1;
  

`




const Dashboard = () => {

 

  const { t } = useTranslation();

  return (
    <Dash>
      <Wrapper>
        <Left>
            <DashLogo src={image} />
            <LeftCaption>
              <Link>
                {t("dashboardNav.left.leftCaption")}
              </Link>
              </LeftCaption>
        </Left>
        <Center>
            <CenterCaption>
                <Link>
                  {t("dashboardNav.center.centerCaption1")}
                </Link>
              </CenterCaption>
            <CenterCaption>
                    <Link>
                    {t("dashboardNav.center.centerCaption2")}
                    </Link>
              </CenterCaption>
          </Center>
        <Right>

            <DashIcons>

              <DashIconContainer>
                    <WalletIcon />
              </DashIconContainer>
              <DashIconContainer>
                    <Account />
              </DashIconContainer>
              <DashIconContainer>
                  <Rentals />
              </DashIconContainer>
              <DashIconContainer>
                  <Message />
              </DashIconContainer>
              <NotificationIcon />

            </DashIcons>
        </Right>
      </Wrapper>
    </Dash>

  );
};

export default Dashboard;
